class HeaderDrawerSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init()
    }

    init() {
        this.initElements();
        this.initSlider();
    }

    initElements() {
        this.prevButton = this.querySelector('[data-header-drawer-slider-prev]');
        this.nextButton = this.querySelector('[data-header-drawer-slider-next]');
    }

    initSlider() {
        this.sliderOptions = {
            slidesPerView: "auto",
            spaceBetween: 0,
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
            }
        }

        this.slider = new Swiper(this, this.sliderOptions)
    }
}

customElements.define('header-drawer-slider', HeaderDrawerSlider);